import * as ng from 'angular';
import AppConstants from '../../gorillaboy/AppConstants';
import {GetTasksResponse, Task, Action} from '../../types/TaskTypes';
import TasksService from '../TasksService';

import './transfer_resources_task.html';
import {IAuthenticatedUserService} from "../../types/ServiceTypes";
import SignalProvider from "../../gorillaboy/SignalProvider";
import {IModalScope} from "../../types/angular-types";

interface IScope extends IModalScope {
    formData : {
        message: string,
        searchUserName: string
    };
    assigneeName: string;

}

function TransferResourcesTaskCtrl($scope: IScope, $log: ng.ILogService, TasksService: TasksService,
     authenticatedUser: IAuthenticatedUserService,
     $translate: ng.translate.ITranslateService, $q: ng.IQService,
     FileService: any, MessageManager: any, DocumentService: any, TypeaheadService: any) {

    $log.info("TransferResourcesTaskCtrl init");

    var transferByNotOwnerErrorMessage = 'the owner of transfer ownership task should also be the owner of related resource',
        duplicateTransferTaskErrorMessage = 'one resource can only have one transfer ownership task';

    $scope.$on(SignalProvider.ResourceSelectionComponent.SelectionUpdated, ($event, data) => {
       $scope.showSection = false;
       $scope.selectedResource = data;
    });

    $scope.formData = {message: '', searchUserName: ''};
    $scope.selectedResource = null;
    $scope.showSection = false;
    $scope.assigneeName = '';

    $scope.browseFilesHandler = function() {
        $scope.showSection = true;
    };

    $scope.getSelectedResourceName = function() {
        if (!$scope.selectedResource) {
            return '';
        }
        return $scope.selectedResource.VersionMetadata ? $scope.selectedResource.VersionMetadata.Name : $scope.selectedResource.Name;
    }

    function errorCreateTask(response) {
        if (response && response.exceptionMessage && response.exceptionMessage.Message && response.exceptionMessage.Message.includes(transferByNotOwnerErrorMessage)) {
            MessageManager.addErrorMessage($translate.instant('TASKS.CREATE_TASK_MODAL.ERROR_MESSAGES.CREATE_FAILED_NOT_OWNER'));
        } else if (response && response.exceptionMessage && response.exceptionMessage.Message && response.exceptionMessage.Message.includes(duplicateTransferTaskErrorMessage)) {
            MessageManager.addErrorMessage($translate.instant('TASKS.CREATE_TASK_MODAL.ERROR_MESSAGES.CREATE_FAILED_DULPICATE_TASK'));
        } else {
            MessageManager.addErrorMessage($translate.instant('TASKS.CREATE_TASK_MODAL.ERROR_MESSAGES.CREATE_FAILED_DEFAULT'));
        }
        $log.error("Task creation has failed" + JSON.stringify(response));
    }

    function errorCreateTaskAssignment() {
        MessageManager.addErrorMessage($translate.instant('TASKS.TRANSFER_OWNERSHIP.MODAL.ERROR_MSGS.COULD_NOT_CREATE_TASK', {
            ResourceName: $scope.getSelectedResourceName()
        }));
        $scope.$dismiss();
    }

    $scope.sendBtnClicked = function() {
        TasksService.createTask(null, $scope.formData.message, $scope.selectedResource.Id,
            AppConstants.TASKDEF_IDS.TRANSFER_RESOURCE_OWNERSHIP)
        .then( response => {
            TasksService.createTaskAssignment(response.Task.Id, $scope.assigneeId, 'USER')
            .then(() => {
                MessageManager.addSuccessMessage($translate.instant('TASKS.TRANSFER_OWNERSHIP.MODAL.SUCCESS_MSGS.CREATED_TASK', {
                    ResourceName: $scope.getSelectedResourceName()
                }));
                $scope.$close();
            }, errorCreateTaskAssignment);
        }, errorCreateTask);
    };

    $scope.typeAheadSelect = function(item) {
        $log.debug("typeAheadSelect called" + item.metadata.Id);
        $scope.assigneeId = item.metadata.Id;
        if ($scope.assigneeId) {
            $scope.assigneeName = $scope.getFullName(item.metadata);
        } else {
            $scope.assigneeName = '';
        }

        if ($scope.formData.searchUserName) {
            $scope.formData.searchUserName = '';
        }
    };

    $scope.searchUsers = function(query) {
        var deferred = $q.defer(),
            searchUsersParams = {
                excludeSelf: true,
                reuseLastSearchOnError: true,
                showQueryAsMatch: false
            };

        TypeaheadService.searchUsers(query, searchUsersParams).then(
            function resolveSuccess(userCollaboratorWrappers) {
                deferred.resolve(userCollaboratorWrappers);
            },
            function resolveFailure() {
                deferred.resolve([]);
            });

        return deferred.promise;
    };

}

TransferResourcesTaskCtrl.$inject = ['$scope',
    '$log',
    'TasksService',
    'authenticatedUser',
    '$translate',
    '$q',
    'FileService',
    'MessageManager',
    'DocumentService',
    'TypeaheadService'
];

angular.module('GorillaBoy.Tasks')
.controller('TransferResourcesTaskCtrl', TransferResourcesTaskCtrl);
